export const cdnUrl = 'https://creme-caramel-images.fra1.cdn.digitaloceanspaces.com/';
